import type { jsPDF } from "jspdf";

export type SendReceiptEmailParams = {
  recipientEmail: string;
  parishName?: string;
  deaneryName?: string;
  presidentName: string;
  presidentContactNumber: string;
  animatorName: string;
  animatorContactNumber: string;
  registrationType: "main" | "pitch_battle";
  doc: jsPDF;
  fileName: string;
};

export async function sendReceiptEmail(params: SendReceiptEmailParams): Promise<boolean> {
  try {
    const pdfArrayBuffer = params.doc.output("arraybuffer");
    const uint8 = new Uint8Array(pdfArrayBuffer);
    let binary = "";
    const len = uint8.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(uint8[i]);
    }
    const pdfBase64 = window.btoa(binary);

    const payload = JSON.stringify({
      recipientEmail: params.recipientEmail,
      parishName: params.parishName,
      deaneryName: params.deaneryName,
      presidentName: params.presidentName,
      presidentContactNumber: params.presidentContactNumber,
      animatorName: params.animatorName,
      animatorContactNumber: params.animatorContactNumber,
      registrationType: params.registrationType,
      pdfBase64,
      fileName: params.fileName,
    });

    const endpoints = [
      "https://senddycregistrationreceipt-f5v5da2yxa-uc.a.run.app",
    ];

    for (const url of endpoints) {
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: payload,
        });

        if (response.ok) {
          return true;
        }

        console.warn(`Endpoint ${url} responded with status: ${response.status}`);
      } catch (err) {
        console.warn(`Failed to connect to ${url}:`, err);
      }
    }

    return false;
  } catch (error) {
    console.error("Error sending receipt email:", error);
    return false;
  }
}
